import { apiGet, apiPatch } from '../../../shared/api-client/index.js';

export interface WorkspaceSettingsResponse {
  workspaceId: string;
  featureFlags: Record<string, boolean>;
}

export interface UpdateWorkspaceSettingsInput {
  featureFlags: Record<string, boolean>;
}

export function getWorkspaceSettingsQueryKey(workspaceId: string): readonly [string, string] {
  return ['workspace-settings', workspaceId] as const;
}

export async function getWorkspaceSettings(): Promise<WorkspaceSettingsResponse> {
  return apiGet<WorkspaceSettingsResponse>('/settings/feature-flags');
}

export async function patchWorkspaceSettings(input: UpdateWorkspaceSettingsInput): Promise<WorkspaceSettingsResponse> {
  return apiPatch<WorkspaceSettingsResponse, UpdateWorkspaceSettingsInput>('/settings/feature-flags', input);
}
